// src/pages/product/SearchPage.js
import FeaturePageTemplate from './FeaturePageTemplate';

export default function SearchPage() {
  return <FeaturePageTemplate slug="search" />;
}